import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';

import { MLargeFileUpload, MCmsLanguagePicker } from '../components/molecules';
import { CMS_CONFIG } from '../config/cms.config';
import { setCmsHead } from '../redux/head/headActions';
import { uploadPoFile, downloadPoFile } from '../redux/cms/cmsActions';
import withAuthGuard from '../helpers/withAuthGuard';

const mapStateToProps = state => ({
	isUploading: state.cms.isUploading,
	uploadingFailed: state.cms.uploadingFailed,
	languages: state.head.utilities.languages,
});

class PoUploadPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			language: undefined,
		};

		this.bindHandle();
	}
	componentDidMount() {
		this.props.setCmsHead({
			...CMS_CONFIG.PO.header.overview,
			onClick: this.handleDownload,
		});
	}

	componentWillReceiveProps(props) {
		if (!this.state.language && props.languages.length > 0) {
			this.setState({ language: props.languages[0].uuid });
		}
	}

	bindHandle() {
		this.handleChange = this.handleChange.bind(this);
		this.handleLanguageSwitch = this.handleLanguageSwitch.bind(this);
		this.handleDownload = this.handleDownload.bind(this);
	}

	handleLanguageSwitch(language) {
		this.setState({ language });
	}

	handleChange(file) {
		this.props.uploadPoFile(({ file: file[0], language: this.state.language }));
	}

	handleDownload() {
		this.props.downloadPoFile({ language: this.state.language });
	}

	render() {
		const language = this.props.languages.find(lang => lang.uuid === this.state.language);
		let fileUploadPlaceholder = `Upload po file voor ${get(language, 'name', '')}`;

		if (this.props.uploadingFailed) {
			fileUploadPlaceholder = `Upload voor ${get(language, 'name', '')} is mislukt`;
		}

		return (
			<div className="layout-cms--content-body layout-cms--create-po layout-cms--content-body-grey">
				<div className="section-cms--language-picker">
					<MCmsLanguagePicker
						items={this.props.languages}
						active={this.state.language}
						onClick={this.handleLanguageSwitch}
					/>
				</div>
				<MLargeFileUpload
					id="PoFileUpload"
					isUploading={this.props.isUploading}
					placeholder={fileUploadPlaceholder}
					onChange={this.handleChange}
				/>
			</div>
		);
	}
}

PoUploadPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	uploadPoFile: PropTypes.func.isRequired,
	downloadPoFile: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	uploadPoFile,
	downloadPoFile,
})(PoUploadPage)));



// WEBPACK FOOTER //
// ./src/CMS/po-upload.page.js